/** O desenho de cada área, nó a nó, na grade de 24 px do Lucide.
 *
 *  Copiado dos ícones do `lucide-react` instalado, e não importado como componente,
 *  porque a arte do card se redesenha traço a traço: cada filho do SVG precisa de
 *  `pathLength` e de um atraso próprio, e o componente pronto não deixa chegar
 *  neles. Ver `AreaArte.tsx`.
 *
 *  Ícone novo segue o mesmo traço: grade de 24, linha, pontas arredondadas, sem
 *  preenchimento e sem fundo. Se o Lucide não tiver um do domínio, desenhe um. */
import type { AreaKey } from './areas'

export type NoDaArte =
  | readonly ['path', { readonly d: string }]
  | readonly ['circle', { readonly cx: number; readonly cy: number; readonly r: number }]

export const ARTE_DAS_AREAS: Readonly<Record<AreaKey, readonly NoDaArte[]>> = {
  // Truck
  logistica: [
    ['path', { d: 'M14 18V6a2 2 0 0 0-2-2H4a2 2 0 0 0-2 2v11a1 1 0 0 0 1 1h2' }],
    ['path', { d: 'M15 18H9' }],
    ['path', { d: 'M19 18h2a1 1 0 0 0 1-1v-3.65a1 1 0 0 0-.22-.624l-3.48-4.35A1 1 0 0 0 17.52 8H14' }],
    ['circle', { cx: 17, cy: 18, r: 2 }],
    ['circle', { cx: 7, cy: 18, r: 2 }],
  ],
  // FileText: uma folha só, com as linhas, que é o papel do Administrativo
  // (Amorim, 24/10/2026: "fica formatado de folha"). O prédio, com as alas dos
  // lados, parecia uma folha com outra atrás.
  administrativo: [
    ['path', { d: 'M15 2H6a2 2 0 0 0-2 2v16a2 2 0 0 0 2 2h12a2 2 0 0 0 2-2V7Z' }],
    ['path', { d: 'M14 2v4a2 2 0 0 0 2 2h4' }],
    ['path', { d: 'M10 9H8' }],
    ['path', { d: 'M16 13H8' }],
    ['path', { d: 'M16 17H8' }],
  ],
  // User: uma pessoa só (Amorim, 24/10/2026). O Users do Lucide põe outra atrás.
  dp: [
    ['path', { d: 'M19 21v-2a4 4 0 0 0-4-4H9a4 4 0 0 0-4 4v2' }],
    ['circle', { cx: 12, cy: 7, r: 4 }],
  ],
  // Fuel: a bomba de combustível do setor que todo mundo chama de Abastecimento
  // (27/10/2026). As duas `line` do Lucide viraram `path`, o único traço que a arte
  // desenha além do círculo.
  abastecimento: [
    ['path', { d: 'M3 22h12' }],
    ['path', { d: 'M4 9h10' }],
    ['path', { d: 'M14 22V4a2 2 0 0 0-2-2H6a2 2 0 0 0-2 2v18' }],
    ['path', { d: 'M14 13h2a2 2 0 0 1 2 2v2a2 2 0 0 0 2 2a2 2 0 0 0 2-2V9.83a2 2 0 0 0-.59-1.42L18 5' }],
  ],
}
